import { Route, Switch } from 'react-router-dom';
import React, { Suspense } from 'react';
import { Loading } from '@fides/fides-react-components';

const Log = React.lazy(() => import('../../components/pages/AdministratorTools/Log'));
const LogDetails = React.lazy(() => import('../../components/pages/AdministratorTools/LogDetails'));

export const LogRouter = () => {
  return (
    <Switch>
      <Route path='/log' exact>
        <Suspense fallback={<Loading />}>
          <Log />
        </Suspense>
      </Route>
      <Route path='/log/:uniqueId' exact>
        <Suspense fallback={<Loading />}>
          <LogDetails />
        </Suspense>
      </Route>
    </Switch>
  );
};
